import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import { CreateContactInput } from 'src/graphql'

type Props<T extends CreateContactInput> = {
  contact: T
  onChange: (update: Partial<T>) => void
  countries: string[]
  fields: Pick<TextFieldProps, 'style'>
  regions?: string[]
  isInvalidRegion?: boolean
}

const BasicAddressForm = <T extends CreateContactInput>(props: Props<T>) => {
  const {
    contact: { address1, address2, city, state, postalCode, country },
    fields,
    onChange,
    isInvalidRegion,
    regions,
    countries,
  } = props

  const handleChange = <K extends keyof T>(key: K, value: T[K]) => {
    onChange(({ [key]: value } as unknown) as Partial<T>)
  }

  return (
    <>
      <TextField
        value={address1}
        label={'Address 1'}
        fullWidth={true}
        onChange={e => handleChange('address1', e.target.value)}
        {...fields}
        id="address_1_field"
      />
      <TextField
        value={address2}
        label={'Address 2'}
        fullWidth={true}
        onChange={e => handleChange('address2', e.target.value)}
        {...fields}
      />
      <TextField
        value={city}
        label={'City'}
        onChange={e => handleChange('city', e.target.value)}
        {...fields}
      />
      <TextField
        id={'state_field'}
        select={true}
        onChange={e => handleChange('state', e.target.value)}
        value={state}
        label={'State'}
        name="state"
        error={isInvalidRegion}
        helperText={isInvalidRegion ? 'Please select a region' : undefined}
      >
        {(regions || ['United States']).map((region, index) => (
          <MenuItem
            id={region.split(' ').join('_').toLowerCase()}
            key={index}
            value={region}
          >
            {region}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        value={postalCode}
        label={'Postal Code'}
        onChange={e => handleChange('postalCode', e.target.value)}
        {...fields}
      />
      <TextField
        select={true}
        fullWidth={true}
        label="Country"
        value={country}
        onChange={e => handleChange('country', e.target.value)}
        SelectProps={{
          MenuProps: {
            style: {
              maxHeight: 200,
            },
          },
        }}
        {...fields}
      >
        {countries &&
          countries.map((country, index) => {
            return (
              <MenuItem key={index} value={country}>
                {country}
              </MenuItem>
            )
          })}
      </TextField>
    </>
  )
}

export default BasicAddressForm
